import { ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { StoreModule } from '@ngrx/store';
import { ConfigModule } from 'Angular/config/config.module';
import { NavigationModule } from 'Angular/features/components/navigation/navigation.module';
import { TopBarNavComponent } from 'Angular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import { PublicSecurityHeaderComponent } from 'SecuritiesApp/ts/features/public-security-header/public-security-header.component';
import { getLogger } from 'Angular/state/logger';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
/**
 * Public Security Page
 *
 * Helps to create a smaller bundle for unauthenticated pages.
 */
export class PublicSecurityPageModule {
    ngDoBootstrap(appRef) {
        appRef.bootstrap(TopBarNavComponent);
        appRef.bootstrap(PublicSecurityHeaderComponent);
    }
}
PublicSecurityPageModule.ɵfac = function PublicSecurityPageModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PublicSecurityPageModule)(); };
PublicSecurityPageModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PublicSecurityPageModule });
PublicSecurityPageModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        ConfigModule,
        NavigationModule,
        PublicSecurityHeaderComponent,
        // The top bar autocomplete keeps its results in the store
        StoreModule.forRoot({}, { metaReducers: getLogger() })] });
